module.exports = {
      id: "prothomalo-com-usage",
      viewBox: "0 0 200 27",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#prothomalo-com",
      toString: function () {
        return this.url;
      }
    }